module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/fallback_white-3d6769d5de873a649acf4507af7647ca.svg";